export default defineNuxtRouteMiddleware((to) => {
	const { public: { maintenance: isMaintenanceModeEnabled } } = useRuntimeConfig();

	if (isMaintenanceModeEnabled) {
		if (to.name === 'MerchantContentPage') {
			return;
		}

		throw createError({
			statusCode: 503,
			statusMessage: 'app-is-under-maintenance',
			unhandled: false,
		});
	}
});
